define('components/charts/loaders/cashflow_summary_chart',[
    'components/charts/common',
    'components/charts/tooltip',
    'google_charts!corechart'
], function(common, tooltip) {
    var loader = function($container) {
        var isMini = $container.data('size') == 'mini';
        var contributionLabelOverride = $container.data('contribution-label');
        var data = parseData($container);
        var datatable = createDataTable(data, isMini, contributionLabelOverride);
        var chartOptions = determineChartOptions(data, isMini, $container);

        var chart;
        var constructChart = function() {
            chart = new google.visualization.BarChart($container[0]);
            // Don't show tooltips on the mini bar chart or when in BCM OEF mode
            if (!isMini && !contributionLabelOverride) {
                registerTooltip($container, chart, data, datatable);
            }

            // If the container is hidden, BarChart will emit an 'error' event and show an ugly red error message.
            // We want to catch the 'error' event to get rid of the error message.
            google.visualization.events.addListener(chart, 'error', function() {
                $container.html('');
            });
        };

        constructChart();

        return {
            instance: chart,
            shouldRedrawOnWindowResize: !isMini,
            draw: function() {
                chart.draw(datatable, chartOptions);
            },
            redraw: function() {
                // We need to reconstruct the chart if the chart's container
                // is not visible due to a BarChart bug (same issue as in piechart.js)
                if (!$container.is(':visible') || $container.is(':empty')) {
                    constructChart();
                } else {
                    chartOptions = determineChartOptions(data, isMini, $container);
                    chart.draw(datatable, chartOptions);
                }
            }
        };
    };


    /**
    `json` should contain: {
        // Required
        commitmentAmount: 999,
        totalContributions: 999,
        totalRollovers: 999,
        totalDistributions: 999,
        positionValue: 999,

        // Optional, scales the horizontal axis so that the right edge is maxAmount
        maxAmount: 999,

        // Optional
        dpi: null,
        rvpi: null,
        tvpi: null,
    }
    **/
    function parseData($container) {
        // NOTE: `.data()` will automatically convert to a JS object.
        var data = $container.data('json');

        data._relativeCommitmentOrNull = data.isCompleted ? null : Math.max(0, data.commitmentAmount - data.totalContributions);
        data._positionValueOrNull = data.isCompleted ? null : Math.max(0, data.positionValue);

        return data;
    }


    function determineChartOptions(data, isMini, $container) {
        var options = {
            height: (data.totalContributions || data.commitmentAmount) ? $container.height() : $container.height()/2,
            animation: {
                startup: true,
                duration: 500,
                easing: 'out',
            },
            backgroundColor: 'transparent',
            legend: 'none',
            chartArea: {
                height: isMini ? '100%' : '80%',
                width: isMini ? '100%' : ((data._positionValueOrNull || data._relativeCommitmentOrNull) && $(window).width() < 1200 ? '35%': '46%'),
                top: 0,
                left: isMini ? 0 : 175,
            },
            fontName: common.fontName,
            fontSize: 12,
            vAxis: {
                textStyle: {color: '#777777'},
                viewWindow: {},
                baselineColor: '#CCC',
                gridlines: {
                    color: '#CCC'
                }
            },
            hAxis: {
                baselineColor: isMini ? 'transparent' : '#DDD',
                format: 'short',
                textStyle: {color: '#777777'},
                gridlines: {
                    color: isMini ? 'transparent' : '#DDD'
                }
            },
            bar: {
                groupWidth: '80%'
            },
            isStacked: true,
            enableInteractivity: false,
            series: {
                0: {color: common.colors.contribution},
                1: {color: common.colors.rollover},
                2: {color: common.colors.contributionCommitment},
                3: {color: common.colors.distribution},
                4: {color: common.colors.redemption},
                5: {color: common.colors.distributionBalance},
            },
            annotations: {
                alwaysOutside: true,
                textStyle: {
                    fontSize: 12,
                    color: '#777777',
                },
            },
        };

        var maxAmount = 0;
        
        if (data.maxAmount) {
            maxAmount = data.maxAmount;
        } else {
            var maxContrib = (data.isCompleted ? data.totalContributions :
                              Math.max(data.totalContributions, data.commitmentAmount));
            var maxDistrib = (data.isCompleted ? data.totalDistributions + data.totalRedemptions :
                              Math.max(data.totalDistributions + data.totalRedemptions,
                                       data.totalDistributions + data.totalRedemptions + data.positionValue));
            maxAmount = Math.max(maxContrib, maxDistrib);
        }
        options.hAxis.minValue = 0;
        options.hAxis.maxValue = maxAmount;
        options.hAxis.viewWindow = {
            min: 0, max: maxAmount,
        }

        return options;
    }


    function createDataTable(data, isMini, contributionLabelOverride) {
        var datatable = new google.visualization.DataTable();
        datatable.addColumn({type:'string', label:'category'});
        
        /* IMPORTANT: When adding new columns, be sure to update `contributionsColumns`
           and `seriesIndexLookup` so that we can accurately generate the correct parameters to `getBoundingBox()`.
        */

        datatable.addColumn({type:'number', label:contributionLabelOverride || 'Contributions'}); // Column 1, series 0
        datatable.addColumn({type:'string', role:'style'});
        
        datatable.addColumn({type:'number', label:'Rollover'}); // Column 3, series 1
        datatable.addColumn({type:'string', role:'style'});

        datatable.addColumn({type:'number', label:'Commitment'}); // Column 5, series 2
        datatable.addColumn({type:'string', role:'style'});
        datatable.addColumn({type:'string', role:'annotation'}); // Column 7, series 2
        
        datatable.addColumn({type:'number', label:'Distributions'}); // Column 8, series 3
        datatable.addColumn({type:'string', role:'style'});

        datatable.addColumn({type:'number', label:'Redemptions'}); // Column 10, series 4
        datatable.addColumn({type:'string', role:'style'});
        
        datatable.addColumn({type:'number', label:'Balance'}); // Column 12, series 5
        datatable.addColumn({type:'string', role:'style'});
        datatable.addColumn({type:'string', role:'annotation'}); // Column 14, series 5
        
        if (data.totalContributions || data.commitmentAmount) {
            var cashContributions = data.totalContributions;
            if (data.totalContributions && data.totalRollovers) {
                cashContributions -= data.totalRollovers;
            }
            datatable.addRow([
                data.contributionsLabel,

                cashContributions || null,
                'stroke-color:' + common.colors.contributionStroke + '; stroke-width:1',

                data.totalRollovers || null,
                'stroke-color:' + common.colors.rolloverStroke + '; stroke-width:1',

                data._relativeCommitmentOrNull,
                'stroke-color:' + common.colors.contributionCommitmentStroke + '; stroke-width:1',
                !isMini && data._relativeCommitmentOrNull ? 'Commitment' : null,

                null, null,
                null, null,
                null, null, null
            ]);
        }
        datatable.addRow([
            data.redemptionsLabel + (data.redemptionsLabel ? ' and ' : '') + 'Distributions',
            
            null, null,
            null, null,
            null, null, null,
            
            data.totalDistributions || null,
            'stroke-color:' + common.colors.distributionStroke + '; stroke-width:1',

            data.totalRedemptions || null,
            'stroke-color:' + common.colors.redemptionStroke + '; stroke-width:1',

            data._positionValueOrNull,
            'stroke-color:' + common.colors.distributionBalanceStroke + '; stroke-width:1',
            !isMini && data._positionValueOrNull ? data.positionValueShortLabel : null
        ]);
        
        return datatable;
    }

    function registerTooltip($container, chart, data, datatable) {
        var contributionsColumns = {
            1: true,
            3: true,
            5: true,
            7: true,

            8: false,
            10: false,
            12: false,
            14: false,
        };
        var seriesIndexLookup = {
            contribution: 0,
            commitment: 2,
            distribution: 3,
            balance: 5
        };
        
        tooltip.setTooltipHandler(chart, {
            onlyHoverOnDataPoints: true,
            handler: function(row, column) {
                if (!(column in contributionsColumns)) {
                    return;
                }
                var layout = chart.getChartLayoutInterface();
                var isInContributions = contributionsColumns[column];
                
                if (isInContributions) {
                    var leftBox = layout.getBoundingBox('bar#' + seriesIndexLookup.contribution + '#' + row);
                    var rightBox = data.isCompleted ? null : layout.getBoundingBox('bar#' + seriesIndexLookup.commitment + '#' + row);
                } else {
                    var leftBox = layout.getBoundingBox('bar#' + seriesIndexLookup.distribution + '#' + row);
                    var rightBox = data.isCompleted ? null : layout.getBoundingBox('bar#' + seriesIndexLookup.balance + '#' + row);
                }

                var bbox = leftBox || rightBox;
                if (leftBox && rightBox) {
                    bbox.width += rightBox.width;
                    bbox.height += rightBox.height;
                }

                var d = datatable.getProperty(row, 0, 'd');

                var dpi_rows = '';
                if (typeof data.dpi == 'number') {
                    dpi_rows += '<tr><th class="text-right">DPI</th><td class="text-right">' + common.decimalFormat.formatValue(data.dpi) + 'x</td></tr>';
                }
                if (typeof data.rvpi == 'number') {
                    dpi_rows += '<tr><th class="text-right">RVPI</th><td class="text-right">' + common.decimalFormat.formatValue(data.rvpi) + 'x</td></tr>';
                }
                if (typeof data.tvpi == 'number') {
                    dpi_rows += '<tr><th class="text-right">TVPI</th><td class="text-right">' + common.decimalFormat.formatValue(data.tvpi) + 'x</td></tr>';
                }
                if (isInContributions) {
                    var tooltipBody = '<table class="alignment_table">';
                    if (!data.isCompleted && data.commitmentAmount) {
                        tooltipBody += '<tr><th class="text-right">Commitment</th><td class="text-right">' + common.formatCurrency(data.commitmentAmount, data.currency) + '</td></tr>';
                    }
                    if (data.totalRollovers) {
                        if (data.totalContributions > data.totalRollovers) {
                            tooltipBody += ('<tr><th class="text-right">Total new contributions</th><td class="text-right">' + common.formatCurrency(data.totalContributions - data.totalRollovers, data.currency) + '</td></tr>');
                        }
                        tooltipBody += ('<tr><th class="text-right">Total rollover contributions</th><td class="text-right">' + common.formatCurrency(data.totalRollovers, data.currency) + '</td></tr>');
                    } else if (data.totalContributions) {
                        tooltipBody += ('<tr><th class="text-right">' + data.contributionsLabel + '</th><td class="text-right">' + common.formatCurrency(data.totalContributions, data.currency) + '</td></tr>' +
                                        dpi_rows +
                                        '</table>');
                    }
                } else {
                    var tooltipBody = '<table class="alignment_table">'
                    if (data._positionValueOrNull) {
                        tooltipBody += '<tr><th class="text-right">' + data.positionValueLongLabel + '</th><td class="text-right">' + common.formatCurrency(data._positionValueOrNull, data.currency) + '</td></tr>';
                    }
                    if (data.totalRedemptions) {
                        tooltipBody += '<tr><th class="text-right">' + data.redemptionsLabel + '</th><td class="text-right">' + common.formatCurrency(data.totalRedemptions, data.currency) + '</td></tr>';
                    }
                    if (data.totalDistributions) {
                        tooltipBody += ('<tr><th class="text-right">Total distributions</th><td class="text-right">' + common.formatCurrency(data.totalDistributions, data.currency) + '</td></tr>' +
                                        dpi_rows +
                                        '</table>');
                    }
                }
                
                var offset = $container.offset();
                
                return {
                    title: '',
                    body: tooltipBody,
                    targetX: offset.left + bbox.left + bbox.width/2,
                    targetY: offset.top + bbox.top
                };
            }
        });
    }

    return loader;
});

